import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AskTeacherComponent } from '../../shared/ask-teacher/ask-teacher.component';

@Component({
  selector: 'lp2-ask-teacher-button',
  template: `
    <a class="ask-teacher-button" (click)="openAskTeacher()">
      {{ 'talkNow.submitQuestion' | translate | uppercase }}
    </a>
  `,
  styleUrls: ['./ask-teacher-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskTeacherButtonComponent {
  constructor(private modalService: NgbModal) {}

  openAskTeacher() {
    this.modalService.open(AskTeacherComponent, {
      centered: true,
      size: 'lg',
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/contact-us/ask-teacher-button/ask-teacher-button.component.ts